import React from 'react'
import Search from 'src/app/Search/Search'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AccountTransactionsAppRoute from 'src/navigation/appRoutes/account/accountTransactions.appRoute'
import AccountsAccountsAppRoute from 'src/navigation/appRoutes/accounts/accountsAccounts.appRoute'
import ExpensesOutOfPocketReportsAppRoute from 'src/navigation/appRoutes/expenses/expensesOutOfPocketReports.appRoutes'
import ExpensesTransactionsAppRoute from 'src/navigation/appRoutes/expenses/expensesTransactions.appRoute'
import PeopleMembersAppRoute from 'src/navigation/appRoutes/people/peopleMembers.appRoute'
import VirtualCardsAllCardsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsAllCards.appRoute'
import {
  budgetTransactionsRouteProps,
  searchRouteProps,
} from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const SearchAppRoute: AppRoute = {
  id: AppLocation.Search,
  routeProps: searchRouteProps,
  component: <Search />,
  subRoutes: [],
  exceptions: [
    ExpensesTransactionsAppRoute,
    AccountTransactionsAppRoute,
    // Budgets migrated to flat routing (EX-39748); reference the routeProps
    // directly so search still excludes the budget transactions page.
    { routeProps: budgetTransactionsRouteProps, subRoutes: [] },
    VirtualCardsAllCardsAppRoute,
    AccountsAccountsAppRoute,
    PeopleMembersAppRoute,
    ExpensesOutOfPocketReportsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default SearchAppRoute
